import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "box-content" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "opacity-80 text-body-2" }

import { computed, type PropType } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'MessageBox',
  props: {
  text: String,
  title: String,
  color: {
    type: String as PropType<"error" | "success">,
    default: "success",
  },
  dense: Boolean,
  closable: Boolean,
},
  setup(__props) {

const props = __props;

const icon = computed(() => {
  switch (props.color) {
    case "error":
      return "mdi-alert-outline";
    case "success":
      return "mdi-check-circle-outline";
    default:
      return null;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["message-box d-flex border border-opacity-50 rounded", [
      `text-${__props.color}`,
      `border-${__props.color}`,
      __props.dense ? 'px-3 py-2' : 'px-4 py-3',
    ]])
  }, [
    (icon.value)
      ? (_openBlock(), _createBlock(_component_v_icon, {
          key: 0,
          class: "mr-2 box-icon",
          size: "26px",
          icon: icon.value
        }, null, 8, ["icon"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (__props.title)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            textContent: _toDisplayString(__props.title),
            class: _normalizeClass(["text-body-1 mb-1", { 'pr-6': __props.closable }])
          }, null, 10, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString(__props.text), 1)
        ])
      ])
    ]),
    (__props.closable)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 1,
          class: "close-btn",
          size: "x-small",
          icon: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "24px",
              icon: "mdi-close"
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: _normalizeClass(["bg-layer", [`bg-${__props.color}`]])
    }, null, 2)
  ], 2))
}
}

})